module.exports = __webpack_public_path__ + "img/fournisseursSousMenu.c872b6e4.png";